import {
  Action,
  ActionType,
  DataPatientChildDepartmentResponse,
} from "models/bodyTemperature/patientChildDepartment";
import createReducer from "../../createReducer";

export interface DataPatientChildDepartmentReducerType {
  loading: boolean;
  error?: string;
  dataPatientChildDepartmentResponse?: DataPatientChildDepartmentResponse;
}

const defaultState: DataPatientChildDepartmentReducerType = {
  loading: false,
  error: undefined,
  dataPatientChildDepartmentResponse: undefined,
};

export const dataPatientChildDepartmentReducer =
  createReducer<DataPatientChildDepartmentReducerType>(defaultState, {
    [ActionType.DATA_PATIENT_CHILD_DEPARTMENT](
      state: DataPatientChildDepartmentReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DATA_PATIENT_CHILD_DEPARTMENT_ERROR](
      state: DataPatientChildDepartmentReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.DATA_PATIENT_CHILD_DEPARTMENT_SUCCESS](
      state: DataPatientChildDepartmentReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        dataPatientChildDepartmentResponse: action.payload,
      };
    },
  });
